<script setup>
const props = defineProps({
  mapCenter: { type: Array, required: true },
  mapZoom: { type: Number, required: true },
  tmpMarkerPosition: { type: Object, required: true }
})
const route = useRoute()
const config = useRuntimeConfig()
const isRadarAnimation = useCookie('radarAnimation', { maxAge: 60 * 60 * 24 * 30 })
const isActive = ref(false)
const position = useCookie('mapView')
const markerPosition = useCookie('markerPosition', { default: () => null })
const onClickButton = (weather) => {
  if (weather === 'wind') {
    isActive.value = !isActive.value
  } else {
    position.value = { lat: props.mapCenter[1], lon: props.mapCenter[0], zoom: props.mapZoom }
    if (Object.keys(props.tmpMarkerPosition).length > 0) {
      markerPosition.value = props.tmpMarkerPosition
    }
    const path = createRadarLink(weather, route.path)
    navigateTo(`${config.public.hostDomain}${path}`, { external: true })
  }
}

onMounted(() => {
  if (!isRadarAnimation.value) {
    isActive.value = true
    isRadarAnimation.value = 1
    setTimeout(() => {
      isActive.value = false
    }, 1500)
  }
})
</script>

<template>
  <div class="map__radars">
    <div
      class="map__radars-inner"
      :class="{ active: isActive }"
    >
      <button
        class="map__radar is-selected"
        data-weather="wind"
        @click="onClickButton('wind')"
      >
        <span class="map__radar-icon" />
        <span class="map__radar-text">風</span>
      </button>
      <button
        class="map__radar"
        data-weather="radar"
        @click="onClickButton('radar')"
      >
        <span class="map__radar-icon" />
        <span class="map__radar-text">雨雲</span>
      </button>
      <button
        class="map__radar"
        data-weather="thunder"
        @click="onClickButton('thunder')"
      >
        <span class="map__radar-icon" />
        <span class="map__radar-text">雷</span>
      </button>
      <button
        class="map__radar"
        data-weather="snow"
        @click="onClickButton('rainsnow')"
      >
        <span class="map__radar-icon" />
        <span class="map__radar-text">雨雪</span>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.map__radars {
  .map__radars-inner {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 61px;
    transition: width .4s ease-in-out;
    &.active {
      width: 268px
    }
    &.active {
      &::before {
        opacity: 1;
      }
    }
  }
  .map__radar {
    display: flex;
    align-items: center;
    gap: 3px;
    position: relative;
    padding: 4px 8px 4px 4px;
    border-radius: 100vmax;
    border: 2px solid #FFF;
    background-color: #E6EAEC;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / .15);
    cursor: pointer;
    &.is-selected {
      background-color: #3569C0;
    }
    &:not(:is(.active) *) {
      &:not(.is-selected) {
        opacity: 0;
      }
    }
    .map__radar-icon {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-color: #fff;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      &:is([data-weather="radar"] *) {
        background-image: url('https://gvs.weathernews.jp/onebox/radar/img/icon/icon_rain.svg');
      }
      &:is([data-weather="thunder"] *) {
        background-image: url('https://gvs.weathernews.jp/onebox/radar/img/icon/icon_thunder.svg');
      }
      &:is([data-weather="wind"] *) {
        background-image: url('https://gvs.weathernews.jp/onebox/radar/img/icon/icon_wind.svg');
      }
      &:is([data-weather="snow"] *) {
        background-image: url('https://gvs.weathernews.jp/onebox/radar/img/icon/icon_snow.svg');
      }
    }
    .map__radar-text {
      min-width: 2em;
      color: #000;
      font-size: 12px;
      font-weight: 600;
      line-height: 1em;
      &:is(.is-selected *) {
        color: #FFF;
      }
    }
  }
}
@media screen and (min-width: 830px) {
  .map__radars {
    .map__radars-inner {
      gap: 10px;
      width: 80px;
      &.active {
        width: 350px
      }
    }
    .map__radar {
      gap: 5px;
      transition: background-color .2s ease-in-out;
      &:not(:is(.active) *) {
        &:not(.is-selected) {
          opacity: 1;
        }
      }
      &:hover {
        background-color: #3569C0;
        .map__radar-text {
          color: #FFF;
        }
      }
      .map__radar-icon {
        width: 24px;
        height: 24px;
      }
      .map__radar-text {
        min-width: 2.5em;
        font-size: 14px;
      }
    }
  }
}
</style>
